export default __webpack_public_path__ + "static/media/taureau.e91f6a44.jpg";